<div class="design-step-content">
  <div id="design-area">
    <stage #stage></stage>
    <additional-info-items
        [additionalInfoItems]="additionalInfoItemsDesignArea">
    </additional-info-items>
  </div>
  <input imageUpload #imageSelect id="image-select"
         type="file" multiple accept="image/*"/>

  <div id="toolboxes">
    <!-- Overlay-Toolboxes -->
    <image-toolbox [type]="'overlay'"
                   *ngIf="activeToolbox === 'ImageToolbox'"
    ></image-toolbox>

    <text-toolbox [type]="'overlay'"
                  *ngIf="activeToolbox === 'TextToolbox'"
    ></text-toolbox>

    <ng-container *ngIf="isSmallDevice || isMediumDevice">
      <layout-toolbox
          [style.visibility]="activeToolbox === 'LayoutToolbox' ? 'visible' : 'hidden'"
          [type]="'overlay'"
          *ngIf="isStaticToolboxAvailable('LayoutToolbox')"
          [templateGroups]="templateGroups"
          [templatesSettings]="templatesSettings"
      ></layout-toolbox>

      <gallery-toolbox
          [type]="'overlay'"
          *ngIf="activeToolbox === 'GalleryToolbox'"
      ></gallery-toolbox>

      <preview-toolbox [type]="'overlay'"
          *ngIf="isStaticToolboxAvailable('PreviewToolbox')"
          [style.visibility]="activeToolbox !== 'PreviewToolbox'
              ? 'hidden' : 'visible' "
      ></preview-toolbox>
    </ng-container>

    <!-- Large- & Medium-Layout -->
    <div id="toolboxes-large" *ngIf="toolboxes && !isSmallDevice">
      <span class="product-name">
        {{currentProductName}}
      </span>
      <hr class="product-line-break" />

      <div class="toolbox"
           [class.aii-graphics-team-feature]=
              "additionalInfoItemsToolboxes.length > 0"
           *ngIf="displayProductChooser &&
                  isStaticToolboxAvailable('ProductChooserToolbox')">
        <product-chooser-toolbox #productChooserToolbox
            [type]="'static'"
        ></product-chooser-toolbox>
      </div>

      <additional-info-items
          [additionalInfoItems]="additionalInfoItemsToolboxes">
      </additional-info-items>

      <button class="toolbox active-animation"
              [class.aii-graphics-team-feature]=
                 "additionalInfoItemsToolboxes.length > 0"
              *ngIf="isStaticToolboxAvailable('GalleryToolbox')"
              (click)="photosButtonClicked()">
        <ng-container *ngIf="!isMediumDevice">
          <mat-icon svgIcon="upload"></mat-icon>
          {{ 'i18n.button.uploadPhotos' | translate }}
        </ng-container>
        <ng-container *ngIf="isMediumDevice">
          <mat-icon svgIcon="photos"></mat-icon>
          {{ 'i18n.button.photos' | translate }}
        </ng-container>
      </button>

      <button class="toolbox"
            *ngIf="isStaticToolboxAvailable('LayoutToolbox') &&
                   isMediumDevice"
      >
        <toolbox-trigger
            [triggerName]="'Layout'"
            [toolbox]="'LayoutToolbox'"
        ></toolbox-trigger>
      </button>

      <button class="toolbox"
              *ngIf="showCreateNewTextPlaceholdersButton"
              (click)="createNewTextPlaceholdersButtonClicked()">
        <mat-icon svgIcon="text"></mat-icon>
        <ng-container *ngIf="!isMediumDevice">
          {{ 'i18n.button.createNewTextPlaceholders' | translate }}
        </ng-container>
        <ng-container *ngIf="isMediumDevice">
          {{ 'i18n.button.mobile.createNewTextPlaceholders' | translate }}
        </ng-container>
      </button>

      <div class="toolbox"
           *ngIf="!isMediumDevice && toolboxTabs.length === 1">
        <ng-container *ngIf="toolboxTabs[0] === 'GalleryToolbox'">
          <gallery-toolbox [type]="'static'" [displayTitle]="true"
                ></gallery-toolbox>
        </ng-container>
        <ng-container *ngIf="toolboxTabs[0] === 'LayoutToolbox'">
          <layout-toolbox [displayTitle]="true"
                          [type]="'static'"
                          [templateGroups]="templateGroups"
                          [templatesSettings]="templatesSettings"
          ></layout-toolbox>
        </ng-container>
      </div>

      <div class="tabbed-toolbox"
           *ngIf="!isMediumDevice && toolboxTabs.length > 1">
        <nav>
          <span [class.active]="toolboxTabs[selectedToolboxTabsIndex] === 'LayoutToolbox'"
                (click)="updateSelectedTabbedToolboxIndex('LayoutToolbox')">
            <mat-icon svgIcon="layouts"></mat-icon>
            {{ 'i18n.toolbox.layout.title' | translate }}
          </span>
          <span [class.active]="toolboxTabs[selectedToolboxTabsIndex] === 'GalleryToolbox'"
                (click)="updateSelectedTabbedToolboxIndex('GalleryToolbox')">
            <mat-icon svgIcon="photos"></mat-icon>
            {{ 'i18n.toolbox.gallery.title' | translate }}
          </span>
          <span class="spacer">

          </span>
        </nav>
        <div>
          <ng-container *ngFor="let tab of toolboxTabs">
            <div class="toolbox" [class.active]="toolboxTabs[selectedToolboxTabsIndex] === tab">
              <ng-container *ngIf="tab === 'GalleryToolbox'">
                <gallery-toolbox [type]="'static'"
                                 [displayTitle]="false"
                ></gallery-toolbox>
              </ng-container>
              <ng-container *ngIf="tab === 'LayoutToolbox'">
                <layout-toolbox
                    [displayTitle]="false"
                    [type]="'static'"
                    [templateGroups]="templateGroups"
                    [templatesSettings]="templatesSettings"
                ></layout-toolbox>
              </ng-container>
            </div>
          </ng-container>
        </div>
      </div>

      <button class="toolbox"
              *ngIf="isStaticToolboxAvailable('PreviewToolbox') &&
                     isMediumDevice">
        <toolbox-trigger
            [triggerName]="'Preview'"
            [toolbox]="'PreviewToolbox'"
        ></toolbox-trigger>
      </button>

      <div class="toolbox"
           *ngIf="!isMediumDevice &&
                  isStaticToolboxAvailable('PreviewToolbox')">
        <preview-toolbox [type]="'static'"
        ></preview-toolbox>
      </div>

      <div class="price-box" *ngIf="!displayProductChooser &&
                                    nextProgress">
        <price-display [price]="priceCalculationService.singleProductTotal"
                       [showPriceLabel]="true"
                       [quantity]="productConfig.quantity">
        </price-display>
      </div>
    </div>

    <!-- Small-Layout -->
    <div id="toolboxes-small" *ngIf="toolboxes && isSmallDevice">
      <span class="product-name">
        {{currentProductName}}
      </span>

      <div id="toolbox-triggers" #toolboxTriggers>
        <span class="toolbox"
              *ngIf="displayProductChooser &&
                     isStaticToolboxAvailable('ProductChooserToolbox')"
        >
        <product-chooser-toolbox #productChooserToolbox
            [type]="'static'"
            [style.display]="'none'"
            [style.visibility]="activeToolbox === 'ProductChooserToolbox' ?
                                'visible' : 'hidden'"
        ></product-chooser-toolbox>
          <toolbox-trigger
              *ngIf="displayProductChooser &&
                     isStaticToolboxAvailable('ProductChooserToolbox')"
              [triggerName]="'ProductChooser'"
              (click)="productChooserToolbox.openProductChooserDirectly($event)"
          ></toolbox-trigger>
        </span>

        <button class="toolbox active-animation"
             *ngIf="isStaticToolboxAvailable('GalleryToolbox')"
             (click)="photosButtonClicked()">
          <mat-icon svgIcon="photos"></mat-icon>
          {{ 'i18n.button.photos' | translate }}
        </button>

        <span class="toolbox"
              *ngIf="isStaticToolboxAvailable('LayoutToolbox')"
        >
          <toolbox-trigger
              [triggerName]="'Layout'"
              [toolbox]="'LayoutToolbox'"
          ></toolbox-trigger>
        </span>

        <span class="toolbox"
              *ngIf="isStaticToolboxAvailable('PreviewToolbox')"
        >
          <toolbox-trigger
              [triggerName]="'Preview'"
              [toolbox]="'PreviewToolbox'"
          ></toolbox-trigger>
        </span>

        <button class="toolbox"
                *ngIf="showCreateNewTextPlaceholdersButton"
                (click)="createNewTextPlaceholdersButtonClicked()">
          <mat-icon svgIcon="text"></mat-icon>
          {{ 'i18n.button.mobile.createNewTextPlaceholders' | translate }}
        </button>
      </div>

      <additional-info-items
          [additionalInfoItems]="additionalInfoItemsToolboxes">
      </additional-info-items>

      <div class="price-box"
           [class.aii-graphics-team-feature]=
              "additionalInfoItemsToolboxes.length > 0"
           *ngIf="nextProgress">
        <price-display [price]="priceCalculationService.singleProductTotal"
                       [showPriceLabel]="true"
                       [quantity]="productConfig.quantity">
        </price-display>
      </div>
    </div>

    <progress-buttons [progressChangeable]="progressChangeable">
    </progress-buttons>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/collage-designer/design-step/design-step.component.html